module.exports = __webpack_public_path__ + "img/11.a905335e.jpg";